
import { RouterLink, RouterView } from "vue-router";
import { getFirestore } from "firebase/firestore";
import { initializeApp } from "firebase/app";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import { getAuth } from "firebase/auth";
import FirebaseConfig from "./firebase/FirebaseConfig";
import { defineComponent } from "@vue/runtime-core";
import { getState } from "./pinia/AppState";
import NavPanel from "./components/nav/NavPanel.vue";
import DeprecatedDashboardView from "./views/DeprecatedDashboardView.vue";
import { getState as getNavigationState } from "@/pinia/NavigationState";
import { getUserManager } from "@/firebase/UserManager";
import User from "./model/User";
import { computed, watch } from "vue";
import * as StoreManager from "@/firebase/StoreManager";
import * as ModuleManager from "@/firebase/ModuleManager";
import { ModifierFlags } from "typescript";

import * as Modals from "@/utils/Modals";

export default defineComponent({
  components: {
    NavPanel,
    DeprecatedDashboardView,
  },

  setup() {
    const state = getState();

    // Get browser language (considering different browser implementations)
    const browserLang =
      (navigator.languages && navigator.languages[0]) ||
      navigator.language ||
      "en";

    // Check if language starts with 'fr' (covers fr-FR, fr-CA, etc.)
    state.lang = browserLang.toLowerCase().startsWith("fr") ? "FR" : "EN";

    let navState = getNavigationState();
    let route = useRoute();
    const router = useRouter();

    let auth = getAuth();

    let windowMain = <any>window;
    windowMain.popStateDetected = false;
    windowMain.addEventListener("popstate", () => {
      windowMain.popStateDetected = true;
    });

    let signingInWithToken = false;
    auth.onAuthStateChanged(async function (user) {
      // The initial route supplies token, page and store_id parameters.
      await router.isReady();
      if (state.logoutRequest || signingInWithToken) {
        return;
      }

      if (state.token != null) {
        const token = state.token;
        state.token = null;
        signingInWithToken = true;
        try {
          // An incoming token takes priority over a persisted password session.
          // Explicitly finish login even if the token belongs to the same UID.
          await getUserManager().loginWithToken(token);
        } catch {
          Modals.open(
            "Unable to authentificate using SecurEat token.",
            "Error"
          );
          navState.navigate("login", true);
        } finally {
          signingInWithToken = false;
        }
        return;
      }

      if (user) {
        if (!state.newAccount) {
          try {
            await getUserManager().performLogin(user);
          } catch {
            Modals.open("Unable to sign in to SecurEat.", "Error");
            navState.navigate("login", true);
          }
        }
      } else {
        state.user = null;
        state.userData = null;
        state.dashboardDeprecated = false;
        state.connectedToApi = false;
        state.resetManagers();
        navState.navigate("login");
      }
    });
    return {
      state: state,
      route: route,
    };
  },
});
